import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for DriveItemStore, for use in the registry */ export const DriveItemStoreActionTypes = [
    ActionType.CancelUploadSessionAction,
    ActionType.CancelUploadSessionFailedAction,
    ActionType.CancelUploadSessionSucceededAction,
    ActionType.CreateUploadSessionAction,
    ActionType.CreateUploadSessionFailedAction,
    ActionType.CreateUploadSessionSucceededAction,
    ActionType.FetchDriveItemAction,
    ActionType.FetchDriveItemFailedAction,
    ActionType.FetchDriveItemSucceededAction,
    ActionType.FetchDriveItemsInFolderAction,
    ActionType.FetchDriveItemsInFolderFailedAction,
    ActionType.FetchDriveItemsInFolderSucceededAction,
    ActionType.FetchDriveItemThumbnailAction,
    ActionType.FetchDriveItemThumbnailFailedAction,
    ActionType.FetchDriveItemThumbnailSucceededAction,
    ActionType.FetchDriveItemPermissionsAction,
    ActionType.FetchDriveItemPermissionsFailedAction,
    ActionType.FetchDriveItemPermissionsSucceededAction,
    ActionType.UploadBytesToSessionAction,
    ActionType.UploadBytesToSessionFailedAction,
    ActionType.UploadBytesToSessionSucceededAction,
    ActionType.FetchDriveSiteUrlAction,
    ActionType.FetchDriveSiteUrlFailedAction,
    ActionType.FetchDriveSiteUrlSucceededAction,
    ActionType.FetchDriveItemSensitivityLabelsAction,
    ActionType.FetchDriveItemSensitivityLabelsFailedAction,
    ActionType.FetchDriveItemSensitivityLabelsSucceededAction
];
